export default __webpack_public_path__ + "static/media/avatar-placeholder.c5a81b72.png";